import classNames from "classnames/bind";
import { useCallback, useEffect, useState } from "react";
import { Alert, Loading, Switch, Toast } from "../../../../components";
import { useStoreContext } from "../../../../hooks/useStoreContext";
import {
  aiConfigService,
  getCommonObject,
} from "../../../../services/api/aiConfigService";
import styles from "../Camera.module.css";
import axiosClient from "../../../../services/axiosClient";
import { SettingAIContext } from "../../../../contexts";
import {
  CameraMoveConfig,
  CarPark,
  CommonConfig,
  FireDetectConfig,
  LisencePlateConfig,
  LisencePlateConfigUni,
  MotionConfig,
} from "./source";
import InProcessBuild from "../../../../components/InProcessBuild";
import { configDefault } from "../../../../services/api/configDefault";
import ConfigFRS from "../../../FaceDetection/MangerService/Config";
import { useTranslation } from "react-i18next";
import { listAiTranslate } from "../../../../utils";
const cx = classNames.bind(styles);

function SettingAI({
  cameraCode,
  onClose,
  codeService,
  nameService,
  aiConfig,
  setAiConfig,
  setType
}) {
  const [reGetData, setReGetData] = useState(false);
  const [showReload,setShowReload] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [isUpDate, setIsUpDate] = useState(false);
  const [permissionChange, setPermissionChange] = useState(true);
  const [readyStatus, setReadyStatus] = useState(false);
  const [configCode, setConfigCode] = useState(null);
  const [tabConfig, setTabConfig] = useState();
  const [active, setActive] = useState(0);
  const [listParamsConfig, setListParamsConfig] = useState([]);
  const [start, setStart] = useState("00:00");
  const [end, setEnd] = useState("23:59");
  const [full, setFull] = useState(false);
  const [isSound, setIsSound] = useState(false);
  const [deleteIfOff, setDeleteIfOff] = useState(false);
  const [typeCamera, setTypeCamera] = useState("normal");
  const [nhay, setNhay] = useState(100);
  const [alertDeleteOff, setAlertDeleteOff] = useState(false);
  const [statusHik, setStatusHik] = useState(false);
  const [statusActive, setStatusActive] = useState(true);
  const [titleAlrm, setTitleAlrm] = useState([]);
  const [configAlrm, setConfigAlrm] = useState({ alarm: '100' });
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext();
  const [isChanged, setIsChanged] = useState(false);
  const { t } = useTranslation()
  // check ai
  const getTabConfig = (name, type) => {
    switch (name) {
      case "Phát hiện chuyển động":
        setTabConfig(MotionConfig);
        break;
      case "Phát hiện xâm nhập":
        setTabConfig(CommonConfig);
        break;
      case "Phát hiện camera di chuyển":
        setTabConfig(CameraMoveConfig);
        break;
      case "Nhận dạng biển số xe":
        if (typeCamera === 'UNI_ANPR') {
          setTabConfig(LisencePlateConfigUni);
        } else {
          setTabConfig(LisencePlateConfig);
        }
        break;
      case "Cảnh báo cháy":
        setTabConfig(FireDetectConfig);
        break;
      case "Bãi đỗ xe":
        setTabConfig(CarPark);
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    getTabConfig(nameService, typeCamera);
  }, [nameService, typeCamera]);
  // check permission to change config
  useEffect(() => {
    const permissionCode = dataStore.userType;
    if (permissionCode && permissionCode !== "300920220005") {
      // setPermissionChange(false)
    }
  }, [dataStore.userType]);
  // get default - if camera have default = set this is default to show - else = set default level to show
  const getListConfigAI = async () => {
    try {
      const res = await aiConfigService.get({ cameraCode, codeService });
      return res;
    } catch (error) {
      throw error;
    }
  };
  // lấy danh sách loại cấu hình
  const getListParams = async (code) => {
    try {
      const res = await axiosClient.get(
        `aiServiceParam/get-list-ai-service-param/?service_code=${code}`
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
  // lấy danh sách mức độ của loại cấu hình
  const getListLevelParams = async (listParam) => {
    try {
      const res = await aiConfigService.postListValueParam(listParam);
      return res;
    } catch (error) {
      // Toast.open('Bạn không có quyền cấu hình AI', 'danger')
    }
  };
  // lấy danh sách cấu hình mặc định
  const getDefaultConfig = async () => {
    try {
      const defConfig = await configDefault.getAllConfig();
      const listParamAI = defConfig.data.filter(
        (item) => item.TYPE === "AI" || item.TYPE === codeService
      );
      const valueAI = [];
      listParamAI?.forEach((item) => {
        switch (item.KEY) {
          case "IS_ZOOM":
            setFull(item.VALUE === "1" ? true : false);
            break;
          case "IS_VOICE":
            setIsSound(item.VALUE === "1" ? true : false);
            break;
          case "DELETE_IF_OFF":
            setDeleteIfOff(item.VALUE === "1" ? true : false);
            break;
          case "TIME_START_ACTIVE":
            setStart(item.VALUE);
            break;
          case "TIME_END_ACTIVE":
            setEnd(item.VALUE);
            break;
          case "TIME_KEEPING_EVENT_DEFAULT":
            setAiConfig({
              ...aiConfig,
              TIME_KEEPING: item.VALUE,
            });
            break;
          case "TIME_ALERT_EVENT":
            setAiConfig({
              ...aiConfig,
              TIME_ALERT_EVENT: item.VALUE,
            });
            break;
          default:
            valueAI.push(item);
            break;
        }
      });
      return valueAI;
    } catch (error) {
      // // console.log(error);
    }
  };
  const mergeDataDefault = async (params, data) => {
    let dataFormatted = [...params];
    const listParamCode = dataFormatted?.map((item) => {
      return {
        ai_param_code: item.AI_PARAM_CODE,
      };
    });
    let levels = [];
    levels = await getListLevelParams(listParamCode);
    dataFormatted.forEach((item, index) => {
      const levelParam = levels.find(
        (it) => it[0].AI_PARAM_CODE === item.AI_PARAM_CODE
      );
      dataFormatted[index].LEVEL = levelParam ? levelParam : [];
    });
    if (data.length >= 1) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < dataFormatted.length; j++) {
          if (data[i].AI_PARAM_CODE === dataFormatted[j].AI_PARAM_CODE) {
            dataFormatted[j].DEFAULT_LEVEL_CODE = data[i].AI_PARAM_LEVEL_CODE;
            dataFormatted[j].DEFAULT_LEVEL_NAME = data[i].PARAM_LEVEL;
          }
        }
      }
    } else {
      for (let i = 0; i < dataFormatted.length; i++) {
        let code = dataFormatted[i].AI_PARAM_CODE;
        let minDuration =
          nameService === "phát hiện chuyển động" ? "Cao" : "Thấp";
        let sensitive =
          nameService === "phát hiện chuyển động" ? "Thấp" : "Trung bình";
        let minObjectSize =
          nameService === "phát hiện chuyển động" ? "Lớn" : "Trung bình";
        let illuminationThresh =
          nameService === "phát hiện chuyển động" ? "Trung bình" : "Thấp";
        let maxDissapear = "Trung bình";
        let carDetConfidenceThreshold = "Thấp";
        let direction = "Từ trên xuống";
        switch (dataFormatted[i].PARAM) {
          case "min_duration":
            let levelDefaultMd = dataFormatted[i].LEVEL.find(
              (item) =>
                item.PARAM_LEVEL === minDuration && item.AI_PARAM_CODE === code
            );
            dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultMd.CODE;
            dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultMd.PARAM_LEVEL;
            break;
          case "illumination_thresh":
            let levelDefaultIt = dataFormatted[i].LEVEL.find(
              (item) =>
                item.PARAM_LEVEL === illuminationThresh &&
                item.AI_PARAM_CODE === code
            );
            dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultIt.CODE;
            dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultIt.PARAM_LEVEL;
            break;
          case "confidence_threshold":
            let levelDefaultCt = dataFormatted[i].LEVEL.find(
              (item) =>
                item.PARAM_LEVEL === "Cao" && item.AI_PARAM_CODE === code
            );
            dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultCt.CODE;
            dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultCt.PARAM_LEVEL;
            break;
          case "sensitive":
            let levelDefaultS = dataFormatted[i].LEVEL.find(
              (item) =>
                item.PARAM_LEVEL === sensitive && item.AI_PARAM_CODE === code
            );
            dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultS.CODE;
            dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultS.PARAM_LEVEL;
            break;
          case "min_object_size":
            let levelDefaultMos = dataFormatted[i].LEVEL.find(
              (item) =>
                item.PARAM_LEVEL === minObjectSize &&
                item.AI_PARAM_CODE === code
            );
            dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultMos.CODE;
            dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultMos.PARAM_LEVEL;
            break;
          case "max_dissapear":
            let levelDefaultMdr = dataFormatted[i].LEVEL.find(
              (item) =>
                item.PARAM_LEVEL === maxDissapear && item.AI_PARAM_CODE === code
            );
            dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultMdr.CODE;
            dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultMdr.PARAM_LEVEL;
            break;
          case "car_det_confidence_threshold":
            let levelDefaultCdct = dataFormatted[i].LEVEL.find(
              (item) =>
                item.PARAM_LEVEL === carDetConfidenceThreshold &&
                item.AI_PARAM_CODE === code
            );
            dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultCdct.CODE;
            dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultCdct.PARAM_LEVEL;
            break;
          case "direction":
            let levelDefaultD = dataFormatted[i].LEVEL.find(
              (item) =>
                item.PARAM_LEVEL === direction && item.AI_PARAM_CODE === code
            );
            dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultD?.CODE;
            dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultD?.PARAM_LEVEL;
            break;
          case "parking_point":
            let levelDefaultPp = dataFormatted[i].LEVEL.find(
              (item) => item.AI_PARAM_CODE === code
            );
            dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultPp?.CODE;
            dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultPp?.PARAM_LEVEL;
            break;
          default:
            let levelDefaultDf = dataFormatted[i].LEVEL.find(
              (item) =>
                item.PARAM_LEVEL === "Trung bình" && item.AI_PARAM_CODE === code
            );
            dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultDf?.CODE;
            dataFormatted[i].DEFAULT_LEVEL_NAME = "Trung bình";
            break;
        }
      }
    }
    return dataFormatted;
  };
  useEffect(() => {
    const getDataDefault = async () => {
      try {
        setIsLoading(true);
        const param = await getListParams(codeService);
        const data = await getListConfigAI();
        if (nameService === "Cảnh báo cháy") {
          // // console.log(param, data);
          setIsLoading(false);
          setStatusHik(data?.enabled)
          setTitleAlrm(param)
          setConfigAlrm(data)
        } else {
          if (data.length > 0) {
            const statusAi = data[0]?.STATUS;
            setReadyStatus(statusAi === 1);
            setConfigCode(data[0].AI_SERVICE_CODE);
            const formatData = await mergeDataDefault(param, data);
            setIsLoading(false);
            setListParamsConfig(formatData);
          } else {
            if (typeCamera === "HIK" && nameService === "Cảnh báo cháy") {
              setNhay(data?.sensitivityLevel);
              const enable = data?.enabled === 'true' ? true : false;
              setStatusHik(enable);
              setIsLoading(false);
            } else {
              const dataDefault = await getDefaultConfig();
              const formatData = await mergeDataDefault(param, []);
              const listParamValue = formatData.map((item) => {
                const dfItem = dataDefault.find(
                  (it) => it.KEY.toLowerCase() === item.PARAM
                );
                return {
                  ...item,
                  DEFAULT_LEVEL_CODE: dfItem?.AI_PARAM_LEVEL_CODE
                    ? dfItem.AI_PARAM_LEVEL_CODE
                    : 1,
                  DEFAULT_LEVEL_NAME: item?.LEVEL
                    ? item.LEVEL.find(
                      (i) =>
                        i.CODE ===
                        (dfItem?.AI_PARAM_LEVEL_CODE
                          ? dfItem.AI_PARAM_LEVEL_CODE
                          : 1)
                    )?.PARAM_LEVEL
                    : "Tất cả",
                };
              });
              setIsLoading(false);
              setListParamsConfig(listParamValue);
            }
          }
        }
      } catch (error) {
        if (error?.response?.data?.result) {
          Toast.open(error?.response?.data?.result, "danger");
        } else {
          console.log("error", error);
          Toast.open(t("setting.You_do_not_have_permission_to_configure_AI"), "danger");
        }
        setIsLoading(false);
      }
    };
    // Nhận dạng khuôn mặt có API riêng gọi trong compponent của nó
    if (statusActive && codeService !== '20230222000000000002') {
      getDataDefault();
    }
    // eslint-disable-next-line
  }, [
    cameraCode,
    reGetData,
    permissionChange,
    codeService,
    statusActive,
    typeCamera,
  ]);
  useEffect(() => {
    const getTime = async () => {
      try {
        const res = await axiosClient.get(
          `/aiConfig/get-schedule-ai-config/?camera_code=${cameraCode}&ai_service_code=${codeService}`
        );
        setStart(res.TIME_START);
        setEnd(res.TIME_END);
        setFull(res.IS_ZOOM);
        setIsSound(res.IS_VOICE);
        setDeleteIfOff(res.DELETE_IF_OFF);
        setTypeCamera(res.CAMERA_TYPE_CODE);
        setType(res.CAMERA_TYPE_CODE);
      } catch (e) { }
    };
    getTime();
  }, [cameraCode, codeService, reGetData]);
  const turnOnAIService = async () => {
    setIsLoading(true);
    const listCode = listParamsConfig.map((config) => {
      return config.DEFAULT_LEVEL_CODE || 31;
    });
    try {
      await aiConfigService.configAi({
        cameraid: cameraCode,
        time_keeping: aiConfig?.TIME_KEEPING,
      });
      if (typeCamera !== "HIK") {
        const res = await aiConfigService.update({
          camera_code: cameraCode,
          ai_service_code: codeService,
          ai_param_level_code: {
            code: listCode,
          },
          time_end: end,
          time_start: start,
          is_zoom: full ? "1" : "0",
          is_voice: isSound ? "1" : "0",
          delete_if_off: deleteIfOff ? "1" : "0",
        });
        if (isChanged) {
          Toast.open(`${t("smartReport.on")} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.success')}`, "success");
        } else {
          Toast.open(`${t("setting.Setting")} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.success')}`, "success");
        }
        setIsChanged(false);
        setIsLoading(false);
        return res;
      } else {
        if (nameService === "Cảnh báo cháy") {
          // // console.log("zo");
          const res1 = await axiosClient.post(
            "/aiConfig/post-add-fire-detection-hik-config/",
            {
              camera_code: cameraCode,
              enabled: `${statusHik}`,
              // alert:`${configAlrm.alert}`,
              alarm: `${configAlrm.alarm}`,
              // distance: Number(configAlrm.distance)
            }
          );
        }
        else {
          const res1 = await axiosClient.post(
            "/aiConfig/post-add-motion-hik-config/",
            {
              camera_code: cameraCode,
              enabled: `${statusHik}`,
              sensitivityLevel: nhay,
            }
          );
        }

        const res = await aiConfigService.update({
          camera_code: cameraCode,
          ai_service_code: codeService,
          time_end: end,
          ai_param_level_code: {
            code: listCode,
          },
          time_start: start,
          is_zoom: full ? "1" : "0",
          is_voice: isSound ? "1" : "0",
          delete_if_off: deleteIfOff ? "1" : "0",
        });
        if (isChanged) {
          Toast.open(`${t("smartReport.on")} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.success')}`, "success");
        } else {
          Toast.open(`${t("setting.Setting")} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.success')}`, "success");
        }
        setIsChanged(false);
        setIsLoading(false);
        return res;
      }
    } catch (error) {
      if (isChanged) {
        Toast.open(`${t("smartReport.on")} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t("stream.error")}`, "danger");
      } else {
        Toast.open(`${t("setting.Setting")} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t("stream.error")}`, "danger");
      }
      setIsChanged(false);
      setIsLoading(false);
    }
  };
  const turnOffAIService = async (cameraCode, aiServiceCode) => {
    if (aiServiceCode && cameraCode) {
      setIsLoading(true);
      try {
        const res = await aiConfigService.remove(cameraCode, aiServiceCode);
        if (isChanged) {
          Toast.open(`${t("smartReport.off")} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.success')}`, "success");
          setIsChanged(false)
        } else {
          Toast.open(`${t("setting.Setting")} ${listAiTranslate.find(ai => ai.ai_name === nameService).name_tr || nameService} ${t('stream.success')}`, "success");
        }
        setIsChanged(false)
        setIsLoading(false);
        return res;
      } catch (error) {
        if (isChanged) {
          Toast.open(`${t("smartReport.off")} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t("stream.error")}`, "danger");
          setIsChanged(false)
        } else {
          Toast.open(`${t("setting.Setting")} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t("stream.error")}`, "danger");
        }
        setIsChanged(false)
        setIsLoading(false);
      }
    }
    return 0;
  };

  // change config
  const onCancel = () => {
    setReGetData(!reGetData);
    setIsUpDate(false);
  };
  const handleOke = async () => {
    await turnOnAIService();
    setIsUpDate(false);
  };

  const handleChangeParamsConfig = (data) => {
    setListParamsConfig(data);
  };
  const handleChose = (item) => {
    setActive(item);
  };

  const handleCancelDelete = () => {
    setAlertDeleteOff(false);
    setReadyStatus(true);
  };
  const handleAcceptDelete = () => {
    setAlertDeleteOff(false);
    // handleOnChange(false);
  };

  const handleChangeStatusAI = (data) => {
    setIsChanged(true)
    setShowReload(true)
    if (typeCamera === "HIK" && nameService === "Cảnh báo cháy") {
      setStatusHik(data);
    } else {
      setReadyStatus(data);
      if (deleteIfOff && !data) {
        setAlertDeleteOff(true);
      } else {
        // handleOnChange(data);
      }
    }
  };

  const checkSuportFireDetect = (nameService, typeCamera) => {
    if (nameService === "Cảnh báo cháy") {
      if (typeCamera === "HIK") {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  let valueContext = {
    listParamsConfig,
    onClose,
    permissionChange,
    nameService,
    codeService,
    handleChangeParamsConfig,
    turnOnAIService,
    turnOffAIService,
    reGetData,
    mergeDataDefault,
    getListParams,
    setIsLoading,
    setReGetData,
    setIsUpDate,
    cameraCode,
    aiConfig,
    setAiConfig,
    end,
    setEnd,
    start,
    setStart,
    full,
    setFull,
    isSound,
    setIsSound,
    deleteIfOff,
    setDeleteIfOff,
    getDefaultConfig,
    typeCamera,
    setTypeCamera,
    nhay,
    setNhay,
    statusHik,
    setStatusHik,
    titleAlrm,
    configAlrm,
    setConfigAlrm,
    aiStatus: (typeCamera === "HIK" && nameService === "Cảnh báo cháy") ? statusHik : readyStatus,
    isChanged,
    showReload,
    setShowReload
  };
  return (
    <>
      {checkSuportFireDetect(nameService, typeCamera) ?
        <>
          {statusActive ? (
            <>
              {localStorage.getItem("role")?.split(",")?.some(role => role === "S" || role === "A") ? (
                <SettingAIContext.Provider value={valueContext}>
                  {(nameService !== 'Nhận dạng khuôn mặt' && nameService !== 'Nhận diện khuôn mặt') ? (<>
                    {isUpDate && (
                      <Alert
                        onClose={onCancel}
                        onOk={handleOke}
                        title={t("setting.Confirm_reset_to_default")}
                      />
                    )}
                    {alertDeleteOff && (
                      <Alert
                        onClose={handleCancelDelete}
                        onOk={handleAcceptDelete}
                        title={t("setting.Turning_off_the_service_will_delete_all_AI_videos_of_this_camera")}
                      />
                    )}
                    <div className={cx("item-setting")}>
                      <span className={cx("name")}>{t("location.status")}</span>
                      <span
                        style={{ position: "relative", right: 0, marginTop: 0 }}
                        className={cx("info")}
                      >
                        <Switch
                          value={(typeCamera === "HIK" && nameService === "Cảnh báo cháy") ? (statusHik === "true" ? true : false) : readyStatus}
                          type="small"
                          onChange={handleChangeStatusAI}
                          disable={false}
                        />
                      </span>
                    </div>
                    <div className={cx("content-config")}>
                      <div className={cx("controller")}>
                        {tabConfig &&
                          tabConfig?.map((item) => {
                            return (
                              <div
                                className={cx(
                                  "button-control",
                                  active === item.tabIndex && "button-active"
                                )}
                                onClick={() => handleChose(item.tabIndex)}
                                key={item.tabIndex}
                              >
                                {item.tabName}
                              </div>
                            );
                          })}
                      </div>
                      {tabConfig?.map((item) => {
                        if (item.tabIndex === active) {
                          return <div key={item.tabIndex}>{item.component}</div>;
                        } else {
                          return (
                            <span key={item.tabIndex} style={{ display: "none" }}></span>
                          );
                        }
                      })}
                      {isLoading && (
                        <div className={cx("loading-modal")}>
                          <Loading />
                        </div>
                      )}
                    </div>
                  </>) : (
                    <ConfigFRS cameraCode={cameraCode} onClose={onClose} />
                  )}
                </SettingAIContext.Provider>
              ) : <InProcessBuild title={t("settingCam.You_do_not_have_AI_administration_rights")} />}
            </>
          ) : (
            <InProcessBuild />
          )}
        </>
        : <InProcessBuild title={t("settingCam.Camera_company_does_not_support_service")} />}
    </>
  );
}

export default SettingAI;
